<template>
  <v-menu offset-x right :close-on-content-click="false" v-model="open">
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on"><v-list-item-title>Move to site</v-list-item-title></v-list-item>
    </template>
    <v-card flat width="350">
      <v-card-title>Move to site</v-card-title>
      <v-card-text class="pa-0">
        <v-container class="pt-0 px-6">
          <v-row dense>
            <v-col cols="9">
              <date-picker v-model="input.date" @change="refresh()"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-autocomplete v-model="input.toSiteId" outlined dense label="Site"
                              :items="sites" item-text="name" item-value="id"/>
            </v-col>
          </v-row>
        </v-container>
        <v-divider/>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="open=false">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import {format} from 'date-fns'

export default {
  name: 'InventoryCasksBatchMoveSite',
  props: {
    casks: {type:Array, required:true}
  },
  data() {
    return {
      open: false,
      input: {date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
              toSiteId: '',
              ids:this.casks.map(cask => cask.id)},
      saving: false
    }
  },
  computed: {
    sites() {
      return this.$store.getters.sites(true, {B265:true,B266:true});
    }
  },
  async created() {
    this.input.toSiteId = this.sites[0].id;
  },
  methods: {
    async save() {
      this.saving = true;
      const results = await this.$apiCall(`mutation InventoryCasksBatchMoveSite($date: DateTime!, $toSiteId:ID!, $ids:[ID]!) {
                                              exciseVesselsTransferSiteCreate(date:$date, toSiteId:$toSiteId, ids:$ids) {id,error}
                                            }`,
                                          this.input);
      this.saving = false;
      if (!results.error) {
        this.open = false;
        const errorCount = results.data.exciseVesselsTransferSiteCreate.length;
        this.$store.commit('setError', {type:errorCount ? 'warning' : 'success',
                                        message:`Moved ${this.casks.length - errorCount} of ${this.casks.length} casks\
                                                  ${errorCount ? `(${errorCount} error${errorCount > 1 ? 's':''})` : ``}`});
        this.$emit('refresh', results.data.exciseVesselsTransferSiteCreate);
      }
    }
  }
}
</script>